import { convertLinkToBackEnd } from '@utils'

class BaseMap {
  get isBaseMap() {
    return true
  }
  get is2D() {
    return !this.is3D
  }
  constructor(baseMap) {
    Object.assign(this, baseMap)
    this.links = [convertLinkToBackEnd(baseMap.link)]
  }
}
class RasterBasemap extends BaseMap {
  constructor(baseMap) {
    super(baseMap)
    this.maxzoom = baseMap.meta.maxzoom || 22
    this.minzoom = baseMap.meta.minzoom || 0
    this.tileSize = baseMap.meta.tileSize || 256
    this.links = [convertLinkToBackEnd(baseMap.link)]
  }
}
class VectorBasemap extends BaseMap {}

export const BaseMapCreate = (baseMap) => {
  if (baseMap.type == 'vector') return new VectorBasemap(baseMap)
  if (baseMap.type == 'raster') return new RasterBasemap(baseMap)
}

export const BaseMap3dCreate = (baseMap) => {
  if (baseMap.type == 'raster') return new Raster3dBasemap(baseMap)
}
class Raster3dBasemap {
  constructor(baseMap) {
    Object.assign(this, baseMap)
    this.url = convertLinkToBackEnd(baseMap.link)
    this.subdomains = this.meta.subdomains || []
    this.maxzoom = this.meta.maxzoom
  }
}
